import { render, staticRenderFns } from "./Whats.vue?vue&type=template&id=dc0b67c0&scoped=true&"
import script from "./Whats.vue?vue&type=script&lang=js&"
export * from "./Whats.vue?vue&type=script&lang=js&"
import style0 from "./Whats.vue?vue&type=style&index=0&id=dc0b67c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0b67c0",
  null
  
)

export default component.exports